import { mapState } from 'vuex';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    showSwitchVersion() {
      return [191, 285, 390, 263].includes(+this.gameId);
    },
    headerShowSwitchVersion() {
      return (
        this.showSwitchVersion && this.$route.meta.pageName === 'userCenterPage'
      );
    }
  },
  methods: {
    switchVersion() {
      const oldVersionPageMap = {
        191: 'officialStore.html',
        285: 'officialStore.html',
        390: 'officialTopup.html',
        263: 'officialStore.html'
      };
      window.location.href = getGlobalGetGotoLink({
        link: window.location.href
          .replace('officialTopupNew.html', oldVersionPageMap[this.gameId])
          .replace(window.location.hash, '#/')
      });
    }
  }
};
